/** DEV OPTS */
/* eslint-env node*/
/* eslint-disable no-console
 */

import type { Dictionary } from '../types/types';

export const isEmptySID = (sid: null | number = null): boolean => {
   return typeof sid == 'undefined' || sid === null || sid === 0 || isNaN(sid);
};

export const isLocalSID = (sid: null | number = null): boolean => {
   return typeof sid !== 'undefined' && sid !== null && sid < 0 && !isNaN(sid);
};

export const getWindowSize = (): { width: number; height: number } => {
   return {
      width: typeof window != 'undefined' ? window.innerWidth : 0,
      height: typeof window != 'undefined' ? window.innerHeight : 0
   };
};

export const getUrlQueryParams = (router: Dictionary) => {
   const params: Dictionary = {};
   if (router.location.search && router.location.search.substring(0, 1) === '?' && router.location.search.indexOf('=') !== -1) {
      const query = router.location.search.substring(1);
      let parts = [query];
      if (query.indexOf('=') !== -1) parts = query.split('&');

      parts.map((p: string) => {
         if (p.indexOf('=') !== -1) {
            const keyval = p.split('=');
            params[keyval[0]] = decodeURIComponent(keyval[1]);
         }
         return null;
      });
   }
   return params;
};

/**
 * This function is same as PHP's nl2br() with default parameters.
 *
 * @param {string} str Input text
 * @param {boolean} replaceMode Use replace instead of insert
 * @param {boolean} isXhtml Use XHTML
 * @return {string} Filtered text
 */
export const nl2br = (str: string, replaceMode: boolean = false, isXhtml: boolean = false): string => {
   var breakTag = isXhtml ? '<br />' : '<br>';
   var replaceStr = replaceMode ? '$1' + breakTag : '$1' + breakTag + '$2';
   return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr);
};

export const getQueryParamsFromObject = (obj: object)=>{
   return Object.keys(obj).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(obj[k])}`).join('&');
};


export const BrowserAppearance = {
   getColorScheme: (): string => {
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
         return 'dark';
      } else {
         return 'light';
      }
   },
   addEventListener: () => {
      window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
         const newColorScheme = e.matches ? 'dark' : 'light';
         return newColorScheme;
      });
   }
};

export const Appearance: { getColorScheme: Function } = {
   getColorScheme: (): string => {
      return 'light';
   }
};

export const capitalize = (string: string): string => {
   return string.charAt(0).toUpperCase() + string.slice(1);
};

export const ISODateString = (d: Date): string => {
   function pad(n: number) {
      return n < 10 ? '0' + n : n;
   }
   return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()) + 'T' + pad(d.getUTCHours()) + ':' + pad(d.getUTCMinutes()) + ':' + pad(d.getUTCSeconds()) + 'Z';
};

export const toLocalTimestamp = (utc_timestamp?: number): number => {
   let date = new Date();
   if (utc_timestamp) date.setTime(utc_timestamp);
   let localOffset = date.getTimezoneOffset() * 60000;
   let localTime: number = date.getTime();
   const date_number = localTime - localOffset;
   return date_number;
};

export const delay = (t: number): Promise<any> => {
   return new Promise((resolve) => setTimeout(resolve, t));
};
